import { Injectable } from '@angular/core';
import { MetricCrossCompanyDTO } from "./kpi-cross-company.service";
import {
  CHART_COLORS,
  CHART_FONTS, CHART_STYLES,
  HighchartsOptions,
} from "../../../../../shared/component/pie-chart-simple/highcharts-common/highcharts-global-const";
import { KpiCrossCompanyHelperService } from "./kpi-cross-company-helper.service";

@Injectable({
  providedIn: 'root',
})
export class KpiCrossCompanyChartService {

  constructor(
    private helperService: KpiCrossCompanyHelperService,
  ) {
  }

  getOptions(metric: MetricCrossCompanyDTO): HighchartsOptions {
    const metricPeriods =
        [...new Set(metric.companies
          .flatMap((companies) => companies.data
            .filter((d) =>
              this.helperService.rowValueExists(d.rowValue, metric.dataProps.dataType))
            .map((d) => d.period)))]
          .sort();

    const richMetric = this.helperService.enrichMetric(metric, metricPeriods);

    return {
      xAxis: {
        labels: {
          style: { fontSize: CHART_FONTS.font4, color: '#78909C' },
        },
        categories: metricPeriods,
        type: 'category',
        crosshair: true,
        scrollbar: CHART_STYLES.scrollbar,
      },
      yAxis: {
        title: {
          text: undefined,
        },
        labels: CHART_STYLES.yAxisLabelsStyle,
        stackLabels: CHART_STYLES.customKpiStackLabels,
      },
      legend: CHART_STYLES.legend('left'),
      colors: CHART_COLORS.default,
      tooltip: CHART_STYLES.customTooltipKpiAnalysis,
      series: richMetric.companies.map((c) => ({
        name: c.companyName,
        type: 'line',
        marker: { enabled: false },
        data: c.data.map((d) => Number(d.rowValue)),
      })),
    };
  }
}
